import React, { Component } from 'react';
import { Svg } from '../../Gauge';
import { formatLabelIdAndId, GAUGE_CENTER_COORDINATES, GaugeElementId } from '../../shared/GaugeShared';
import { GaugeCenterArrowGroup } from './GaugeCenterArrowGroup';

export interface GaugeCenterProps {
   svg: Svg;
   svgId: string;
   value: number;
   upperBound: number;
   lowerBound: number;
   centerBackgroundColor: string;
}

export class GaugeCenter extends Component<GaugeCenterProps> {
   private CENTER_CIRCLE_RADIUS = 36;

   constructor(props: GaugeCenterProps) {
      super(props);

      this.drawGaugeCenter(props);
   }

   render(): JSX.Element {
      return (
         <GaugeCenterArrowGroup
            {...this.props}
         />
      );
   }

   UNSAFE_componentWillReceiveProps(nextProps: GaugeCenterProps): void {
      this.updateGaugeCenterBackgroundColor(nextProps.svg,
                                            nextProps.svgId,
                                            nextProps.centerBackgroundColor);
   }

   drawGaugeCenter = (props: GaugeCenterProps): void => {
      props.svg.draw.circle(this.CENTER_CIRCLE_RADIUS)
         .center(GAUGE_CENTER_COORDINATES.x, GAUGE_CENTER_COORDINATES.y)
         .attr({
                  id: formatLabelIdAndId(GaugeElementId.CENTER, props.svgId),
                  fill: props.centerBackgroundColor
               });
   };

   updateGaugeCenterBackgroundColor = (svg: Svg,
                                       svgId: string,
                                       centerBackgroundColor: string): void => {
      svg.get(formatLabelIdAndId(GaugeElementId.CENTER, svgId))
         .attr({
                  fill: centerBackgroundColor
               });
   };
}
